import { Globe, Ship, Handshake, BadgeCheck, MapPinned } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const HIGHLIGHTS = [
  {
    number: "01",
    title: "International Sourcing",
    description: "Access to manufacturers and suppliers from around the world.",
    icon: Globe,
  },
  {
    number: "02",
    title: "Import & Supply Expertise",
    description:
      "Extensive experience managing the process of bringing products into the Egyptian market.",
    icon: Ship,
  },
  {
    number: "03",
    title: "Established Industry Relationships",
    description:
      "Long-standing relationships with major industrial organizations and international manufacturers.",
    icon: Handshake,
  },
  {
    number: "04",
    title: "Reliable Products",
    description:
      "We work with established manufacturers and brands to meet customer requirements and specifications.",
    icon: BadgeCheck,
  },
  {
    number: "05",
    title: "Local Market Knowledge",
    description:
      "Deep understanding of the Egyptian market, procurement requirements, and industrial supply needs.",
    icon: MapPinned,
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="bg-[#FBF9F5]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
        <Reveal className="max-w-2xl">
          <span className="font-mono text-xs font-medium tracking-[0.2em] uppercase text-amber-600">
            Our Strengths
          </span>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-slate-900">
            What We Bring to Our Customers
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            With more than three decades of experience, our strength lies in
            combining:
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {HIGHLIGHTS.map((h, i) => {
            const Icon = h.icon;
            return (
              <Reveal key={h.number} delay={0.1 * i}>
                <div
                  data-testid={`service-card-${h.number}`}
                  className="group h-full rounded-2xl border border-slate-200/80 bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:border-amber-500/40"
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#0B2545] transition-colors duration-300 group-hover:bg-amber-500">
                      <Icon className="h-6 w-6 text-white" strokeWidth={1.8} />
                    </span>
                    <span className="font-heading text-4xl font-bold text-slate-100 group-hover:text-amber-100 transition-colors">
                      {h.number}
                    </span>
                  </div>
                  <h3 className="mt-6 font-heading text-xl sm:text-2xl font-semibold text-slate-900">
                    {h.title}
                  </h3>
                  <p className="mt-3 text-slate-600 leading-relaxed">
                    {h.description}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
